import { createStore, type StoreApi } from 'zustand';

import type { RegexPatternsResponse } from '../types/RegexPatternsResponse';

export type RegexPatternsState = {
    regexPatterns: RegexPatternsResponse | null;
};

export type RegexPatternsActions = {
    updateRegexPatterns: (regexPatterns: RegexPatternsState['regexPatterns']) => void;
    resetStore: () => void;
};

export type RegexPatternsStore = RegexPatternsState & RegexPatternsActions;

export const initialState: RegexPatternsState = {
    regexPatterns: null,
};

export function createRegexPatternsStore(regexPatternsState: RegexPatternsState = initialState): StoreApi<RegexPatternsStore> {
    return createStore<RegexPatternsStore>()((set) => ({
        ...regexPatternsState,
        updateRegexPatterns: (regexPatterns): void => {
            set(() => ({ regexPatterns }));
        },
        resetStore: (): void => {
            set(initialState);
        },
    }));
}

